import { api } from '@/api/api'
import { rotasApi } from '@/configurações/rotasApi'
import { useQuery } from '@tanstack/react-query'

export const useTermosDeUsoGet = () => {
  const { data } = useQuery({
    queryKey: ['termos-de-uso'],
    queryFn: async () => await endPoint(),
  })

  return { data }
}

async function endPoint(): Promise<string> {
  const result = await api().get(rotasApi.termosBuscar)
  return result.data.data
}
